module.exports = __webpack_public_path__ + "img/snow.c56c15d6.png";